import { callFunction } from './functionsService';

export async function getCatalogStockStatus() {
  return callFunction('getCatalogStockStatus');
}

export async function checkPurchaseAvailability(coinProductId) {
  return callFunction('checkPurchaseAvailability', { coinProductId });
}

export async function getPurchaseQuote(coinProductId) {
  return callFunction('getPurchaseQuote', { coinProductId });
}

export async function joinCoinPurchaseWaitlist(coinProductId, options = {}) {
  return callFunction('joinCoinPurchaseWaitlist', {
    coinProductId,
    ...options,
  });
}

export async function createCoinCheckoutSession(coinProductId) {
  return callFunction('createCoinCheckoutSession', { coinProductId });
}

export async function getPurchaseStatus(sessionId) {
  return callFunction('getPurchaseStatus', { sessionId });
}
